import { useState, useEffect } from 'react';

export const useGetJsonData = (filePath) => {
  const [humdityZone, setHumdityZone] = useState();
  
  useEffect(() => {
    const getJsonData = async () => {
      const url = `data/${filePath}`
      try {
        const response = await fetch(url, {
          headers : { 
            'Content-Type': 'application/json',
            'Accept': 'application/json'
           }});

        const json = await response.json()

        setHumdityZone(json)
      } catch(e) {
        throw new Error(`Ошибка при загрузке файла ${filePath}`);
      }
    }
    getJsonData();
  }, [filePath])

  return humdityZone
}